var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMpk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 288 108",
    style: {
      enableBackground: "new 0 0 288 108"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:white;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "2.3,6 58.7,6 58.7,19.3 30.4,19.3 30.4,88.9 58.7,88.9 58.7,102 2.3,102 2.3,88.9 29.9,54.2 2.3,19.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.8,29.1h10.3L63,42.2h0.1L66,29.1h10.3v22.1h-6.7V34.8h-0.1l-3.8,16.5h-5.2l-3.8-16.5h-0.1v16.5h-6.7V29.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M80,29.1h10.8c5.5,0,8,2.9,8,6.8c0,4.5-3.2,6.9-9.1,6.9h-2.5v8.4H80V29.1z M87.2,38.7h1.4 c1.8,0,2.8-0.8,2.8-2.7c0-1.8-1-2.7-2.8-2.7h-1.4V38.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.7,29.1h7.2v8.5h0.1l5.3-8.5h7.7l-7,9.7l7.8,12.4h-8.2l-4.2-7.7l-1.5,1.9v5.9h-7.2V29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.8,62.2v-0.5c0-1.3-0.7-2.4-2.1-2.4c-1.5,0-2.2,1-2.2,2c0,4.4,11.8,2.2,11.8,10.3c0,4.7-3.4,6.8-9.8,6.8 c-6,0-9.3-1.6-9.3-6.2v-0.8h7v0.5c0,1.9,1,2.6,2.4,2.6c1.5,0,2.3-0.9,2.3-2.1c0-4.4-11.3-2.2-11.3-10c0-4.5,3-6.9,9.1-6.9 c6.3,0,8.9,2.1,8.9,6.8H60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.3,55.8h10.8c5.5,0,8,2.9,8,6.8c0,4.5-3.2,6.9-9.1,6.9h-2.5v8.4h-7.2V55.8z M77.5,65.3h1.4 c1.8,0,2.8-0.8,2.8-2.7c0-1.8-1-2.7-2.8-2.7h-1.4V65.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.5,55.8h16.4v4.7h-9.2v3.8h8.6v4.5h-8.6v4.4h9.5v4.7H91.5V55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.7,62.5c0-2.5-0.6-3.3-2-3.3c-2.2,0-2.4,1.6-2.4,7.6c0,6,0.2,7.6,2.4,7.6c1.8,0,2.2-1.2,2.2-5.4h7v1.6 c0,6.2-4.5,7.7-9.1,7.7c-8.1,0-9.9-3.3-9.9-11.5c0-8.5,2.4-11.5,9.9-11.5c6.5,0,8.9,2.7,8.9,7v1.4h-7V62.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M131.7,55.8h7.2v22.1h-7.2V55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.3,55.8h9.1l6.7,22.1h-7.7l-0.7-3.9h-5.7l-0.7,3.9h-7.7L147.3,55.8z M151.8,60.3L151.8,60.3l-2.1,9.4h4 L151.8,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.4,55.8h7.2v16.4l7.5,0l0,5.7h-14.7V55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.7,60.7h-5.4v-4.9h18.1v4.9h-5.4v17.2h-7.2V60.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.9,55.4c7.4,0,9.9,3.2,9.9,11.5c0,8.3-2.5,11.5-9.9,11.5c-7.4,0-9.9-3.2-9.9-11.5 C206,58.6,208.5,55.4,215.9,55.4z M215.9,74.4c2.2,0,2.4-1.6,2.4-7.6c0-6-0.2-7.6-2.4-7.6c-2.2,0-2.4,1.6-2.4,7.6 C213.5,72.8,213.7,74.4,215.9,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M237.9,55.4c7.4,0,9.9,3.2,9.9,11.5c0,8.3-2.5,11.5-9.9,11.5c-7.4,0-9.9-3.2-9.9-11.5 C228.1,58.6,230.6,55.4,237.9,55.4z M237.9,74.4c2.2,0,2.4-1.6,2.4-7.6c0-6-0.2-7.6-2.4-7.6c-2.2,0-2.4,1.6-2.4,7.6 C235.5,72.8,235.7,74.4,237.9,74.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250.2,55.8h7.2v16.5h7.3v5.6h-14.6V55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M278.3,62.2v-0.5c0-1.3-0.7-2.4-2.1-2.4c-1.5,0-2.2,1-2.2,2c0,4.4,11.8,2.2,11.8,10.3c0,4.7-3.4,6.8-9.8,6.8 c-6,0-9.3-1.6-9.3-6.2v-0.8h7v0.5c0,1.9,1,2.6,2.4,2.6c1.5,0,2.3-0.9,2.3-2.1c0-4.4-11.3-2.2-11.3-10c0-4.5,3-6.9,9.1-6.9 c6.3,0,9,2.1,9,6.8H278.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMpk);
export default __webpack_public_path__ + "static/media/mpk.a5371f2f20506b47449d4c6f2919e903.svg";
export { ForwardRef as ReactComponent };